import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

class SettingsPayoutAddMethodTransferMethodController extends Controller {
  @service('state-managers/application') applicationStateManager;
  @service('commands/hyperwallet-user-commands') hyperwalletUserCommands;
  @service('commands/payout-account-commands') payoutAccountCommands;
  @service router;
  @service session;
  @service shData;
  @service store;

  @action
  getAuthToken() {
    return this.hyperwalletUserCommands.getHyperwalletUser(this.session.currentUser.id)
      .then((response) => {
        this.shData.pushResponseToStore(response);
        const hyperwalletUser = this.store.peekRecord('hyperwalletUser', response.data.id);
        return hyperwalletUser.authToken;
      });
  }

  @action
  handleSubmitSuccess(transferMethod) {
    this.payoutAccountCommands.syncPayoutAccounts(this.session.currentUser)
      .then((response) => {
        this.shData.pushResponseToStore(response);
        return this.shData.getModelArrayFromResponse(response, 'payoutAccount');
      })
      .then((payoutAccounts) => {
        return payoutAccounts
          .find((payoutAccount) => payoutAccount.providerId === transferMethod.token);
      })
      .then((payoutAccount) => {
        const countryCode = this.model.countryCode;
        const payoutAccountId = payoutAccount.id;

        if (!payoutAccount.preferred) {
          this.router.transitionTo('settings.payout.add-method.select-method', {
            queryParams: { payoutAccountId, countryCode },
          });
          return;
        }

        this.router.transitionTo('settings.payout');
        this.applicationStateManager.addToast('Payout method added');
      });
  }
}

export default SettingsPayoutAddMethodTransferMethodController;
